import { useCallback } from 'react';

import { LIFECYCLE, useLifecycle } from 'hooks/useLifecycle';

export const useInSeasonLocalStorage = (): [
  boolean,
  (value: boolean) => void,
] => {
  const { update: updateLifecycle, lifecycle } = useLifecycle();
  const inSeasonFilterEnabled = lifecycle?.inSeasonFilterEnabled ?? true;

  const setInSeason = useCallback(
    (value: boolean) => {
      updateLifecycle(LIFECYCLE.inSeasonFilterEnabled, value);
    },
    [updateLifecycle]
  );

  return [inSeasonFilterEnabled, setInSeason];
};
